<template>
  <div class="maintenance-wrapper">
    <div class="maintenance-card">
      <feather-icon icon="ToolIcon" size="48" class="mb-2 text-primary" />
      <h2 class="mb-1">Mantenimiento</h2>
      <p class="maintenance-text">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    message() {
      return this.$store.state.maintenance.message
        || 'El sistema está en mantenimiento. Vuelva a intentarlo más tarde.'
    },
  },
}
</script>

<style scoped>
.maintenance-wrapper {
  display: flex; align-items: center; justify-content: center;
  min-height: 100vh; padding: 1rem; text-align: center;
}
.maintenance-card { max-width: 520px; }
.maintenance-text { font-size: 1.1rem; color: #6e6b7b; }
</style>
